import { API_HOST } from "$lib/environment";

/**
 * Performs the bootstrap-token handshake with the BFF.
 *
 * POSTs `Authorization: Bearer <bootstrapToken>` to `<API_HOST>/auth/exchange`
 * with `credentials: 'include'`. The BFF validates the bootstrap token,
 * performs a server-side RFC 8693 token exchange against Keycloak for its
 * own audience, AES-GCM-seals the resulting tokens and returns them as a
 * CHIPS-partitioned HttpOnly session cookie.
 *
 * After this call, all subsequent API requests rely on the session cookie
 * (`credentials: 'include'`); the bootstrap token is never used again.
 *
 * @throws Error if the BFF returns a non-2xx response or the request fails.
 */
export async function exchangeBootstrapToken(token: string): Promise<void> {
  const response = await fetch(`${API_HOST}/auth/exchange`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    credentials: "include",
  });

  if (!response.ok) {
    throw new Error(
      `Bootstrap token exchange failed: ${response.status} ${response.statusText}`,
    );
  }
}
